export default __webpack_public_path__ + "static/canyon_bunker-2248fff0f117bc2e4247c26ed707aed4.png";